import { cn } from '../../lib/utils'

interface FormCheckboxProps {
  label: string
  name: string
  checked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  className?: string
}

export function FormCheckbox({
  label,
  name,
  checked,
  onChange,
  disabled = false,
  className = '',
}: FormCheckboxProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="w-4 h-4 text-primary-500 border-neutral-300 rounded focus:ring-primary-500/15 focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed"
      />
      <label htmlFor={name} className="text-sm text-neutral-700 select-none">
        {label}
      </label>
    </div>
  )
}
